<template>
    <div class="row d-flex flex-row">
        <div class="row d-flex flex-row date-filter-container">
            <div class="queryNameContainer">
                <dx-check-box
                    v-on:valueChanged="toggleInputs"
                    v-model="enableRow"
                    class="query-name-switch global-switch"
                    :text="queryName"
                />
            </div>

            <div id="FromContainer" class="query-column">
                <dx-check-box
                    v-model="enableFrom"
                    :disabled="!enableRow"
                    class="query-name-switch from-to-label"
                    :text="checkBoxLabelFrom"
                />
                <dx-date-box
                    v-model="dateFrom"
                    :disabled="!enableFrom"
                    v-on:valueChanged="newQueryValue"
                    v-on:optionChanged="disableDatepicker"
                    :calendar-options="calendarOptions"
                    class="from"
                />
            </div>
        </div>

        <div class="row d-flex flex-row date-filter-container">
            <div class="queryNameContainer"></div>

            <div id="ToContainer" class="query-column">
                <dx-check-box
                    v-model="enableTo"
                    class="query-name-switch from-to-label"
                    :disabled="!enableRow"
                    :text="checkBoxLabelTo"
                />
                <dx-date-box
                    v-on:valueChanged="newQueryValue"
                    v-model="dateTo"
                    :disabled="!enableTo"
                    v-on:optionChanged="disableDatepicker"
                    class="to"
                    :calendar-options="calendarOptions"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { DxDateBox } from "devextreme-vue/date-box";
import { DxCheckBox } from "devextreme-vue/check-box";

export default {
    components: {
        DxDateBox,
        DxCheckBox,
    },
    data() {
        return {
            enableFrom: false,
            enableTo: false,
            idPrefix: "",
            checkBoxLabelFrom: "",
            checkBoxLabelTo: "",
            enableRow: false,
            dateFrom: null,
            dateTo: null,
        };
    },
    props: {
        queryName: String,
        defaultValFrom: String,
        fieldType: String,
        category: String,
        queryField: String,
        yearOnly: {
            default: false,
            type: Boolean,
        },
    },
    computed: {
        ...mapState({ advancedQueryCriteria: (state) => state.advancedQueryCriteria }),
        calendarOptions: function () {
            return {
                maxZoomLevel: this.yearOnly ? "decade" : "month",
                zoomLevel: "year" 
            };
        },
    },
    methods: {
        ...mapActions([`updateRelationalQuery`, "deleteRelationalQuery"]),
        reboot() {
            this.enableFrom = false;
            this.enableTo = false;
            this.enableRow = false;
            this.dateFrom = null;
            this.dateTo = null;
        },
        getCheckBoxLabels: function (type) {
            if (type === "YearMonthDay") {
                const labelFrom = this.$i18n.CHECKBOX_AFTER_DATE_LABEL;
                const labelTo = this.$i18n.CHECKBOX_BEFORE_DATE_LABEL;

                return { checkboxFrom: labelFrom, checkboxTo: labelTo };
            } else {
                const labelFrom = this.$i18n.CHECKBOX_GREATER_THAN_LABEL;
                const labelTo = this.$i18n.CHECKBOX_LESS_THAN_LABEL;
                // this.calendarOptions = { zoomLevel: "year" };

                return { checkboxFrom: labelFrom, checkboxTo: labelTo };
            }
        },
        newQueryValue: function (event) {
            if (event.value != null)
                if (event.element.className.includes("from"))
                    this.updateRelationalQuery({
                        queryField: this.queryField + "-DateFrom",
                        value: event.value,
                        category: this.category,
                    });
                else
                    this.updateRelationalQuery({
                        queryField: this.queryField + "-DateTo",
                        value: event.value,
                        category: this.category,
                    });
        },
        toggleInputs: function (event) {
            if (!this.enableFrom && !this.enableTo) {
            } else {
                this.enableFrom = false;
                this.enableTo = false;

                this.deleteRelationalQuery({
                    queryField: this.queryField + "-DateFrom",
                    category: this.category,
                });

                this.deleteRelationalQuery({
                    queryField: this.queryField + "-DateTo",
                    category: this.category,
                });
            }
        },
        disableDatepicker: function (event) {
            if (event.fullName === "disabled")
                if (event.component.element().className.includes("from")) {
                    this.dateFrom = null;
                    this.deleteRelationalQuery({
                        queryField: this.queryField + "-DateFrom",
                        category: this.category,
                    });
                } else if (event.component.element().className.includes("to")) {
                    this.dateTo = null;
                    this.deleteRelationalQuery({
                        queryField: this.queryField + "-DateTo",
                        category: this.category,
                    });
                }
        },
    },
    mounted() {
        const labels = this.getCheckBoxLabels(this.fieldType);
        this.checkBoxLabelFrom = labels.checkboxFrom;
        this.checkBoxLabelTo = labels.checkboxTo;
    },
};
</script>

<style scoped>
.queryNameContainer {
    flex: 0 1 220px;
    display: flex;
    justify-content: flex-start;
    align-content: center;
}

div:nth-child(n + 2) {
    float: right;
}

[type="text"] {
    width: 150px;
    height: 15px;
}

.btn {
    padding: 0px;
}

.input-append {
    position: relative;
    left: -1px;
    top: 8px;
}

.input-append > div {
    padding-left: 0px;
    margin-left: 0px;
}

.input-group-btn > .btn {
    padding: 10px;
}

.d-flex .flex-column {
    position: relative;
    left: -31px;
}

.input-group-addon span {
    padding-left: 10px;
}

#dateValueFrom,
#dateValueTo {
    border-top-right-radius: 0rem;
    border-bottom-right-radius: 0rem;
}

.dx-switch,
.dx-checkbox {
    display: flex !important;
    margin-right: 10px;
}

.query-column {
    display: flex;
    justify-content: flex-start;
    align-content: center;
}

.row {
    width: 100% !important;
}

.date-filter-container {
    margin-left: 0 !important;
}

.from-to-label {
    min-width: 110px;
}

.date-filter-container {
    padding-bottom: 5px;
}

.global-switch {
    min-height: 40px;
}

/* VSCode and VS will underline the >>> as an error, but it's actually the Vue.js 'deep' combinator
    All it does is allow you to affect child components in a scoped stylesheet
    But it doesn't play nicely with commas, hence the repeating styles */

>>> span.dx-checkbox-text {
    margin-bottom: -20px;
}

>>> .dx-checkbox-container {
    display: flex;
    align-self: center;
}

>>> .dx-checkbox-icon {
    display: flex;
    align-self: center;
}

>>> .dx-checkbox-text {
    display: flex;
    align-self: center;
}

>>> .dx-checkbox-checked .dx-checkbox-icon {
    color: #0275d8;
}

>>> span {
    font-weight: lighter;
}

>>> .dx-item-content {
    font-weight: lighter;
}
</style>
 